import React, { useMemo } from 'react';
import { Col, Row, Badge } from 'react-bootstrap';

import dayjs from 'dayjs';
import { MyApplicationComment } from '../../api/openapi';

interface Props {
  item: MyApplicationComment;
}

const getInitials = (str: string): string => {
  const names = str.split(' ');
  let initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }

  return initials;
};

const ApplicationCommentBox: React.FC<Props> = ({ item }: Props) => {
  const initials = useMemo(() => getInitials(item.createdBy?.name || ''), [item]);
  return (
    <>
      <div style={{ display: 'block', paddingTop: '15px' }}>
        <div style={{ display: 'inline-block', marginRight: '10px' }}>
          <Badge
            variant="light"
            pill
            className="font-weight-normal"
            style={{ padding: '0.5em', borderRadius: '50%', fontSize: '0.75rem', lineHeight: 'inherit', minWidth: '2.6em' }}
          >
            {initials}
          </Badge>
        </div>
        <div style={{ display: 'inline-block' }}>
          <span style={{ color: 'deepskyblue' }}>{item.createdBy?.name}</span>{' '}
          <span style={{ color: 'lightgray' }} className="pl-2">
            {dayjs(item.createdAt).format('DD.MM.YYYY HH:mm')}
          </span>
        </div>
      </div>
      <div style={{ paddingLeft: '40px' }}>
        <Row>
          <Col md={6}>{item.comment}</Col>
        </Row>
      </div>
    </>
  );
};
export default ApplicationCommentBox;
